/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @author Matěj Grabovský <matej.grabovsky@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import EventEmitter from 'eventemitter3';
import isNil from 'lodash/isNil';

/**
 * @private
 * @typedef {import('../../control/control-listener').ControlListener} ControlListener
 * @typedef {import('../../control/control-listener').EventTypes} EventTypes
 */

// TODO: Přejmenovat a přemístit, protože se používá vícero platformami.
/**
 * Naslouchač událostem v ovládání pro standardní webové technologie.
 * Je navázaný na standardní DOM rozhraní pro stisky kláves.
 * Filtruje události a převádí je do {@link EventBus} rozhraní pro události.
 * @implements {ControlListener}
 */
export default class WebControlListener {
  /**
   * Vytvoří instanci.
   * @param {import('../../control/control-parser').ControlParser} parser Převaděč kódů tlačítek na číselník.
   */
  constructor(parser) {
    /** @type {EventEmitter<EventTypes>} */
    this.emitter = new EventEmitter();
    this.parser = parser;
    // Navázání naslouchání na instanci.
    this.onKeydown = this.onKeydown.bind(this);
    // Naslouchání událostem.
    document.addEventListener('keydown', this.onKeydown);
  }

  /** @type {ControlListener['destroy']} */
  destroy() {
    document.removeEventListener('keydown', this.onKeydown);
  }

  /** @type {ControlListener['off']} */
  off(type, callback) {
    this.emitter.off(type, callback);
  }

  /** @type {ControlListener['on']} */
  on(type, callback) {
    this.emitter.on(type, callback);
  }

  /**
   * Reakce na stisk tlačítka.
   * @param {KeyboardEvent} event Vyvolaná událost.
   * @private
   */
  onKeydown(event) {
    const controlButton = this.parser.parseKeyCode(event.keyCode);
    if (!isNil(controlButton)) {
      this.emitter.emit('buttonDown', controlButton);
    }
  }
}
